module.exports = __webpack_public_path__ + "static/media/High_Street_Pheonix.9c2456ce.png";